import { intlShape } from 'react-intl';
import { transitionToStep } from 'launch/actions/designBriefActions';
import DraftStepStore from 'launch/stores/DraftStepStore';
import PropTypes from 'prop-types';
import React from 'react';
import StepProgressBar from 'launch/components/StepProgressBar';
import connectToStores from 'fluxible-addons-react/connectToStores';

class BriefHeader extends React.Component {
    static propTypes = {
        currentStep: PropTypes.string.isRequired,
        steps: PropTypes.array.isRequired,
        header: PropTypes.string.isRequired,
        paragraph: PropTypes.string.isRequired,
    };

    static contextTypes = {
        executeAction: PropTypes.func.isRequired,
        intl: intlShape.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.currentStep !== this.props.currentStep;
    }

    transitionToStep(step) {
        this.context.executeAction(transitionToStep, step);
    }

    translatedSteps() {
        const { formatMessage } = this.context.intl;

        let steps = {};
        this.props.steps.forEach(step => {
            steps[step] = formatMessage({ id: `steps.${step}` });
        });

        return steps;
    }

    renderProgressBar() {
        const { currentStep } = this.props;

        return (
            <div className="row">
                <div className="column">
                    <div className="brief-header__progress">
                        <StepProgressBar
                            steps={this.translatedSteps()}
                            currentStep={currentStep}
                            onClickStep={this.transitionToStep.bind(this)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="brief-header">
                <div className="brief-header__inner row">
                    <div className="column">
                        <h1 className="brief-header__inner__heading">{this.props.header}</h1>
                        <p className="brief-header__inner__sub-heading">{this.props.paragraph}</p>
                    </div>
                </div>

                {this.renderProgressBar()}
            </div>
        );
    }
}

export default connectToStores(BriefHeader, [DraftStepStore], (context, props) => {
    const store = context.getStore(DraftStepStore);
    const { id, header, paragraph } = store.getCurrentStep();

    return {
        steps: store.getSteps(),
        currentStep: id,
        header,
        paragraph,
    };
});
